export default __webpack_public_path__ + "static/media/logo_Sixtema_Bianco_mobile.5dfdc85e.png";